import React from 'react';
import { m } from 'framer-motion';
import { SectionTag } from '../ui/SectionTag';
export function Hero() {
  return <header className="relative overflow-hidden bg-bg-primary pb-10 pt-8 sm:pb-12 sm:pt-10" data-id="element-103" data-mp="7xt4fnxpamea">
      <div className="relative mx-auto flex max-w-4xl flex-col items-center px-4 text-center sm:px-6" data-id="element-104" data-mp="cvl4544l7ct1">
        <m.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} data-id="element-105" data-mp="hvz3lxs4hefg">
          <SectionTag icon="🪵" data-id="element-106" data-mp="qvdtow4dnmzf">Para carpinteros y manitas con taller en casa</SectionTag>
        </m.div>

        <m.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="mt-5 font-heading text-4xl font-extrabold uppercase leading-[1.08] tracking-tight text-ink sm:text-5xl md:text-6xl" data-id="element-107" data-mp="vlu74g8778ls">
          El Kit del Taller <span className="text-brown" data-id="element-108" data-mp="1akejemj2w0ru">Rentable</span>
        </m.h1>

        <m.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.18
      }} className="mt-5 max-w-2xl text-base leading-relaxed text-muted sm:text-lg" data-id="element-109" data-mp="9oc84mzmpti7">
          Transforma tus retales (o un tablero del Leroy) en más de{' '}
          <span className="font-semibold text-ink" data-id="element-110" data-mp="3rv0aw677i4kp">500€/mes</span> con micro-productos de alta demanda en
          España.
        </m.p>

        {/* Plain img (no entrance animation): keeps paint instant once it downloads. */}
        <img src="https://cdn.magicpatterns.com/uploads/f2WswFoBnvLSR7DDANnFPV/ChatGPT_Image_23_ago_2026__10_47_59-removebg-preview.webp" alt="El Kit del Taller Rentable: colección de 5 tomos y 5 bonos con planos de carpintería" width={500} height={500} loading="eager" fetchPriority="high" decoding="async" className="mt-8 w-full max-w-md sm:max-w-lg" data-id="element-111" data-mp="nhagrb131i3p" />
      </div>
    </header>;
}